import React, { FC } from 'react'
import { withRouter } from 'react-router-dom'

const SignupHeader: FC = () => {
  return (
    <div className="signup-header">
      <img src="/assets/maverick-logo.png" alt="app-logo" className="logo" />
    </div>
  )
}

export default withRouter(SignupHeader)
